
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/upsc-skillup-prelims-programme",
      function () {
        return require("private-next-pages/upsc-skillup-prelims-programme/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/upsc-skillup-prelims-programme"])
      });
    }
  